import React, { PureComponent } from 'react';


class TitleBlock extends PureComponent {
    render() {
        const { title } = this.props;
        return (
            <div className="titleblock">
                <h1 className="titleblock-subtitle">ABOUT THE QUIZ</h1>
                <h1 className="titleblock-title">So, what's<br/>this quiz all<br/>about?</h1>
            </div>
        )
    }
}

export default TitleBlock;



// WEBPACK FOOTER //
// ./src/About/TitleBlock.js